// External resources
import 'popper.js';
import 'jquery';
import 'bootstrap';
import '@fortawesome/fontawesome-free/js/all.js';
import 'select2'

import $ from 'jquery';
import jQuery from 'jquery';
import Sortable from "sortablejs";
import Chart from 'chart.js/auto';
import tippy from 'tippy.js';

// Ugly assign stuff on window to use in templates
// Please remove me!
window.$ = $;
window.jQuery = jQuery;
window.Sortable = Sortable;
window.Chart = Chart;
window.tippy = tippy;

// Custom resources
import './javascript/resource-calendar';
import './javascript/reservation-calendar'
import dateSorter from "./javascript/date-sorter";
import './javascript/tinymce'

window.dateSorter = (a, b) => dateSorter(a, b);
